import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Drawer, Form } from 'antd';

import { ItemTypeTitles } from './utils';

import EditBackgroundIdentificationTemplate from './item-forms/edit-background-identification-template';
import EditLicenseTemplate from './item-forms/edit-license-template';
import EditCertificationTemplate from './item-forms/edit-certification-template';
import EditAssessmentTemplate from './item-forms/edit-assessment-template';
import EditHealthDocumentTemplate from './item-forms/edit-health-document-template';
import EditOtherDocumentTemplate from './item-forms/edit-other-document-template';
import EditImmigrationTemplate from './item-forms/edit-immigration-template';
import FormActions from './form-actions';

function EditItemForm({ dismiss, item, form }) {
  function renderForm(type) {
    switch (type) {
      case 'background_identification':
        return (
          <EditBackgroundIdentificationTemplate
            form={form}
            item={item}
            dismiss={dismiss}
          />
        );
      case 'immigration':
        return (
          <EditImmigrationTemplate form={form} item={item} dismiss={dismiss} />
        );
      case 'license':
        return (
          <EditLicenseTemplate form={form} item={item} dismiss={dismiss} />
        );
      case 'certification':
        return (
          <EditCertificationTemplate
            form={form}
            item={item}
            dismiss={dismiss}
          />
        );
      case 'assessment':
        return (
          <EditAssessmentTemplate form={form} item={item} dismiss={dismiss} />
        );
      case 'health_document':
        return (
          <EditHealthDocumentTemplate
            form={form}
            item={item}
            dismiss={dismiss}
          />
        );
      case 'other_document':
        return (
          <EditOtherDocumentTemplate
            form={form}
            item={item}
            dismiss={dismiss}
          />
        );
    }
  }

  return (
    <React.Fragment>
      <React.Fragment>{renderForm(item.type)}</React.Fragment>
    </React.Fragment>
  );
}

EditItemForm.propTypes = {
  item: PropTypes.object.isRequired,
  dismiss: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
};

function EditItemTemplateModal(props) {
  const [form] = Form.useForm();
  const { visible, setVisible, item } = props;

  if (!visible) return null;

  return (
    <Drawer
      title={`Edit ${ItemTypeTitles[item.type]} Item`}
      width={550}
      visible={visible}
      onClose={() => setVisible(false)}
      footer={
        <FormActions
          onCancel={() => setVisible(false)}
          onSubmit={form.submit}
        />
      }
    >
      <EditItemForm form={form} item={item} dismiss={() => setVisible(false)} />
    </Drawer>
  );
}

EditItemTemplateModal.propTypes = {
  item: PropTypes.object.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
};

export default function EditItemTemplate(props) {
  const [visible, setVisible] = useState(true);
  const { item, dismiss } = props;

  const cancelEdit = () => {
    setVisible(false);
    dismiss();
  };

  return (
    <React.Fragment>
      <EditItemTemplateModal
        item={item}
        visible={visible}
        setVisible={cancelEdit}
      />
    </React.Fragment>
  );
}

EditItemTemplate.propTypes = {
  item: PropTypes.object.isRequired,
  dismiss: PropTypes.func.isRequired,
};
